import { contractStates } from 'shared/constants/contractStates';
import { fetchApi, getUserId } from 'shared/functions';

export const fetchEsgContractData = () => {
  const userId = getUserId();

  return fetchApi('/esg/api/contract-data/')
    .then((response: Response) => response.json())
    .then(
      ({
        users,
        is_trial: isTrial,
        allowed_requests: allowedRequests,
        total_amount: totalAmount,
        contract_state: contractState,
      }) => ({
        esgIsTrial: isTrial,
        esgRequestPermission: contractState === contractStates.ACTIVE && users.includes(userId),
        esgRequestsAllowed: allowedRequests,
        esgTotalAmount: totalAmount,
        esgContractState: contractState,
      }),
    );
};
